var _a
export var RecoilKeys = {
  MobileOnlyGNBToggleMenuButtonIsOpen: 'ODGNB.MobileOnlyGNBToggleMenuButtonIsOpen',
  SelectedMenuItem: 'ODGNB.SelectedMenuItem',
  FooterCollapsibleMenuOpen: 'ODGNB.FooterCollapsibleMenuOpen',
}
export var SCREEN_SIZE
;(function (SCREEN_SIZE) {
  SCREEN_SIZE['xs'] = 'xs'
  SCREEN_SIZE['sm'] = 'sm'
  SCREEN_SIZE['md'] = 'md'
  SCREEN_SIZE['lg'] = 'lg'
  SCREEN_SIZE['xl'] = 'xl'
})(SCREEN_SIZE || (SCREEN_SIZE = {}))
export var SCREEN_WIDTH =
  ((_a = {}),
  (_a[SCREEN_SIZE.xs] = 640),
  (_a[SCREEN_SIZE.sm] = 768),
  (_a[SCREEN_SIZE.md] = 1024),
  (_a[SCREEN_SIZE.lg] = 1280),
  (_a[SCREEN_SIZE.xl] = Infinity),
  _a)
export * from './odAppOptions'
export * from './globalInterfaces'
export * from './globalLayoutInterfaces'
export * from './breadcrumbInterfaces'
export * from './gnbInterfaces'
export * from './odAppOptions'
export * from './odGraphConcept'
export * from './commonLayoutInterfaces'
export * from './routesInterfaces'
//# sourceMappingURL=index.js.map
